export default "__VITE_ASSET__CLoFr$ik__"